import React, { useEffect, useRef, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Spin } from "antd";
import { getCurrentUser } from "../../authPatient/redux/thunks/authThunks";
import ROUTES from "./routePaths";

export default function ProtectedRoute({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const auth = useSelector((s) => s.auth || {});
  const { user } = auth;
  const [status, setStatus] = useState(() => user ? "authenticated" : "loading");
  const started = useRef(false);

  useEffect(() => {
    if (user) {
      setStatus("authenticated");
      return;
    }
    if (started.current) return;
    started.current = true;
    dispatch(getCurrentUser()).unwrap()
      .then(() => setStatus("authenticated"))
      .catch(() => {
        ["patientAccessToken"].forEach((key) => {
          try {
            window.localStorage.removeItem(key);
            window.sessionStorage.removeItem(key);
          } catch { /* Storage can be unavailable in restricted browsers. */ }
        });
        setStatus("unauthenticated");
      });
  }, [dispatch, user]);

  if (status === "loading") {
    return <div role="status" aria-label="Loading session" style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}><Spin size="large" /></div>;
  }
  if (status === "unauthenticated") {
    return <Navigate to={ROUTES.LOGIN} replace state={{ from: location }} />;
  }

  return children;
}
